import { render, staticRenderFns } from "./PizzaSet.vue?vue&type=template&id=7aca7a3c&scoped=true"
import script from "./PizzaSet.vue?vue&type=script&lang=js"
export * from "./PizzaSet.vue?vue&type=script&lang=js"
import style0 from "./PizzaSet.vue?vue&type=style&index=0&id=7aca7a3c&prod&lang=less&scoped=true"
import style1 from "./PizzaSet.vue?vue&type=style&index=1&id=7aca7a3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca7a3c",
  null
  
)

export default component.exports